module.exports = __webpack_public_path__ + "img/pressureSensorLow.a9f0e372.svg";